import { render, staticRenderFns } from "./CatalogMoveView.vue?vue&type=template&id=65bff0e1&"
import script from "./CatalogMoveView.vue?vue&type=script&lang=js&"
export * from "./CatalogMoveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports